import BreadcrumbWithLink from "components/Common/BreadcrumbWithLink";
import ConfirmModal from "components/shared-components/ConfirmModal";
import RemoteDataTable from "components/shared-components/RemoteTable/data-table";
import { actionAccess } from "constants/actionAccess";
import { ORDER_TYPE, TRANSFER_ORDER_TYPE } from "constants/order";
import {
  CheckActionAccess,
  CheckActionAccessList,
  splitText,
} from "helpers/utils";
import {
  useCancelOrder,
  useCancelOrderReasonList,
  useExportMyOrders,
  useMyOrderList,
  useOrderStatus,
  useTypeOrder,
} from "hooks";
import React, { useEffect, useRef, useState } from "react";
import { DateRangePicker } from "react-dates";
import "react-dates/initialize";
import "react-dates/lib/css/_datepicker.css";
import { useTranslation } from "react-i18next";
import MetaTags from "react-meta-tags";
import { useNavigate } from "react-router-dom";
import { useToasts } from "react-toast-notifications";
import {
  Button,
  Card,
  CardBody,
  Col,
  Dropdown,
  DropdownItem,
  DropdownMenu,
  DropdownToggle,
  Row,
  Spinner,
  Label,
} from "reactstrap";
import { Switch } from "antd";
import "./my-orders.scss";
import { orderStatusMode, orderTypeMode } from "./utils";
import RefCode from "pages/Orders/RefCode";
import { checkItemAcceptForUpdateExitsRefCode } from "pages/Orders/utils";
import UpdateRefCodeModal from "pages/ ScanTheRow/UpdateRefCode/UpdateRefCodeModal";
import GroupButtonOrderType, {
  findOrderType,
} from "pages/ManageOrders/GroupButtonOrderType";

const MyOrderPage = () => {
  const { t } = useTranslation(["myOrders"]);
  const navigate = useNavigate();

  const updateRefCodeModalRef = useRef(null);

  const allFilterOption = {
    value: "All",
    label: t("filters.all"),
  };

  /* ================================== START INIT STATE ==================================== */

  const [columnsTable, setColumnsTable] = useState([]);
  const [actionType, setActionType] = useState(false);
  const [selectedRow, setSelectedRow] = useState({});
  const [statusFilter, setStatusFilter] = useState(false);
  const [selectedStatusFilter, setSelectedStatusFilter] = useState("");
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);
  const [focusedInput, setFocusedInput] = useState(null);
  const [filterType, setFilterType] = useState(TRANSFER_ORDER_TYPE.RECEIVE);
  // const [is_level_2, setIsLevel2] = useState(true);
  const initParams = () => {
    return {
      sizePerPage: 10,
      page: 1,
      sort: "-maker_date",
      columnFilter: {
        "filter[type]": filterType,
        // "filter[is_new_address]": is_level_2 ? "N" : "O",
      },
      keywords: "",
    };
  };
  const [orderParams, setOrderParams] = useState(initParams);
  const [selectedIds, setSelectedIs] = useState([]);
  const [selectedOrderCode, setSelectedOrderCode] = useState([]);
  const [dataCancelOrder, setDataCancelOrder] = useState({
    orderId: null,
  });
  const [cancelOrderModal, setCancelOrderModal] = useState(false);
  const [statusListAllOptions, setStatusListAllOptions] = useState([]);
  const [isFilterConsolidated, setIsFilterConsolidated] = useState(false);

  // const handleChangeIsLevel2 = value => {
  //   setIsLevel2(value);
  //   setOrderParams((prev) => ({
  //     ...prev,
  //     columnFilter: {
  //       ...prev.columnFilter,
  //       "filter[is_new_address]": value ? "N" : "O",
  //     },
  //     page: 1,
  //   }));
  // };
  /* =================================== END INIT STATE ===================================== */

  /* ===================================== START HOOKS ====================================== */

  const isAllowCreate = CheckActionAccess(
    actionAccess.GLOG_FUNCTION_MY_ORDER_ADD
  );
  const isAllowExport = CheckActionAccess(
    actionAccess.GLOG_FUNCTION_MY_ORDER_EXPORT
  );

  // CANCEL ORDER

  const handleCancelOrder = () => {
    listOrders();
  };

  const { mutate: cancelOrder } = useCancelOrder(handleCancelOrder);

  // REASONS

  const { refetch: onFetchReasonList, data: reasonListData } =
    useCancelOrderReasonList(1);

  // STATUS LIST

  const onFetchStatusListSuccess = status => {
    setStatusListAllOptions([allFilterOption, ...status]);
  };

  const { refetch: onFetchStatusList, data: statusList } = useOrderStatus(
    onFetchStatusListSuccess
  );

  // EXPORT ORDER

  const exportParams = {
    ...orderParams,
    columnFilter: {
      ...orderParams.columnFilter,
      "filter[id][in]": selectedIds,
    },
  };

  const onExportSuccess = data => {
    if (data) {
      const outputFilename = `ExportFile-${Date.now()}.xlsx`;
      const url = URL.createObjectURL(new Blob([data]));
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", outputFilename);
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      URL.revokeObjectURL(url);
    }
  };

  const { isLoading: isExportingFile, refetch: exportOrders } =
    useExportMyOrders(
      {
        params: exportParams,
      },
      onExportSuccess
    );

  // ORDER LIST

  const {
    data: fetchOrders,
    isFetching: isLoadingListOrder,
    refetch: listOrders,
  } = useMyOrderList({
    params: orderParams,
  });

  // TYPE ORDER
  const { addToast } = useToasts();
  const { data: listOrderType } = useTypeOrder();

  useEffect(() => {
    setOrderParams(prev => ({
      ...prev,
      page: 1,
      sizePerPage: 10,
      columnFilter: {
        ...prev.columnFilter,
      },
      run: true,
    }));

    onFetchStatusList();
  }, []);

  useEffect(() => {
    if (orderParams && orderParams.run) {
      listOrders();
    }
  }, [orderParams]);

  useEffect(() => {
    if (fetchOrders) {
      setColumnsTable(initColumns);
      setSelectedIs([]);
    }
  }, [fetchOrders]);

  useEffect(() => {
    setColumnsTable(initColumns);
  }, [statusListAllOptions]);

  /* ===================================== END HOOKS ======================================== */

  /* ================================ START FUNCTION HANDLER ================================ */

  const formatStatus = cell => {
    const status = statusList.find(item => parseInt(item.value) === cell);
    return <div>{status?.label}</div>;
  };

  const clickViewOrderHandler = row => {
    switch (row.type) {
      case ORDER_TYPE.COLLECTOR.value:
        window.open(
          `/collection-order/${row.id}`,
          "_blank",
          "noopener,noreferrer"
        );
        break;

      default:
        window.open(`/my-orders/${row.id}`, "_blank", "noopener,noreferrer");
        break;
    }
  };

  const rightClickViewOrderHandler = (row, indexCol, e) => {
    if (e && (e.button === 1 || e.button === 2)) {
      switch (row.type) {
        case ORDER_TYPE.COLLECTOR.value:
          window.open(
            `/collection-order/${row.id}`,
            "_blank",
            "noopener,noreferrer"
          );
          break;

        default:
          window.open(`/my-orders/${row.id}`, "_blank", "noopener,noreferrer");
          break;
      }
    }
  };

  const clickCopyOrderHandler = row => {
    localStorage.setItem("copied_order", JSON.stringify(row));
    // const orderType = row?.order_code.charAt(0);
    // if (orderType === "A") {
    //   navigate("/my-orders/hcm-create");
    // } else {
    //   navigate("/my-orders/district-create");
    // }
    navigate("/my-orders/create");
  };

  const toggleCancelOrderModal = () => {
    setCancelOrderModal(!cancelOrderModal);
  };

  const clickCancelOrderHandler = row => {
    setSelectedRow(row);
    setDataCancelOrder({ orderId: row.id });
    toggleCancelOrderModal();
    onFetchReasonList();
  };

  const cancelSingleOrderHandler = value => {
    if (value.reasonId) {
      cancelOrder({
        orderId: dataCancelOrder.orderId,
        reason_note: value.note,
        reason_id: value.reasonId,
        order_code: selectedRow?.["order_code"],
      });
      toggleCancelOrderModal();
    }
  };

  const handleTableChange = (
    type,
    { page, sizePerPage, sortField, sortOrder }
  ) => {
    const columnFilter = orderParams.columnFilter || {};

    // @ts-ignore
    setOrderParams(prev => ({
      ...prev,
      sort: sortField ? sortOrder + sortField : orderParams.sort,
      columnFilter: columnFilter,
      page: page || 1,
      sizePerPage: sizePerPage || 10,
    }));
  };

  const handleRowsSelect = (ids, row) => {
    setSelectedIs(ids);
    setSelectedOrderCode(row.map(item => item.order_code));
  };

  const columnFilterDateHandler = isRunner => {
    const columnFilter = { ...orderParams.columnFilter };

    if (isRunner) {
      switch (true) {
        case columnFilter.hasOwnProperty("filter[maker_date][gte]"):
          columnFilter["filter[action_date][gte]"] =
            columnFilter["filter[maker_date][gte]"];
          delete columnFilter["filter[maker_date][gte]"];
        case columnFilter.hasOwnProperty("filter[maker_date][lte]"):
          columnFilter["filter[action_date][lte]"] =
            columnFilter["filter[maker_date][lte]"];
          delete columnFilter["filter[maker_date][lte]"];
      }
    } else {
      switch (true) {
        case columnFilter.hasOwnProperty("filter[action_date][gte]"):
          columnFilter["filter[maker_date][gte]"] =
            columnFilter["filter[action_date][gte]"];
          delete columnFilter["filter[action_date][gte]"];
        case columnFilter.hasOwnProperty("filter[action_date][lte]"):
          columnFilter["filter[maker_date][lte]"] =
            columnFilter["filter[action_date][lte]"];
          delete columnFilter["filter[action_date][lte]"];
      }
    }

    return columnFilter;
  };

  const handleConsolidatedFilter = () => {
    const columnFilter = columnFilterDateHandler(!isFilterConsolidated);

    setIsFilterConsolidated(!isFilterConsolidated);

    if (!isFilterConsolidated) {
      columnFilter["filter[is_sub_order]"] = 1;
      columnFilter["filter[parent_id]"] = "NULL";
      columnFilter["filter[status]"] = "1";
      setSelectedStatusFilter("Tạo đơn");
    } else {
      delete columnFilter["filter[is_sub_order]"];
      delete columnFilter["filter[parent_id]"];
      delete columnFilter["filter[status]"];
      setSelectedStatusFilter("");
    }

    setOrderParams(prev => ({
      ...prev,
      columnFilter,
    }));
  };

  const handleStatusFilter = status => {
    const columnFilter = { ...orderParams.columnFilter };

    if (status.value !== "All") {
      setSelectedStatusFilter(status?.label);
      columnFilter["filter[status]"] = status.value;
    } else {
      setSelectedStatusFilter("");
      delete columnFilter["filter[status]"];
    }

    setOrderParams(prev => ({
      ...prev,
      columnFilter,
    }));
  };

  const onSearchAllHandle = value => {
    setOrderParams(prev => ({
      ...prev,
      keywords: value,
    }));
  };

  const handleDateRangeFilter = ({ startDate, endDate }) => {
    const columnFilter = { ...orderParams.columnFilter };
    setStartDate(startDate);
    setEndDate(endDate);
    delete columnFilter["filter[maker_date][gte]"];
    delete columnFilter["filter[maker_date][lte]"];
    delete columnFilter["filter[maker_date][eq]"];
    let keyFilter = "maker_date";
    if (startDate && endDate) {
      columnFilter[`filter[${keyFilter}][gte]`] = startDate
        ? startDate.format("YYYY-MM-DD")
        : null;
      columnFilter[`filter[${keyFilter}][lte]`] = endDate
        ? endDate.format("YYYY-MM-DD")
        : null;
    } else if (startDate) {
      columnFilter[`filter[${keyFilter}][eq]`] = startDate
        ? startDate.format("YYYY-MM-DD")
        : null;
    } else if (endDate) {
      columnFilter[`filter[${keyFilter}][eq]`] = endDate
        ? endDate.format("YYYY-MM-DD")
        : null;
    }

    setOrderParams(prev => ({
      ...prev,
      columnFilter,
    }));
  };

  const handleExportFile = () => {
    if (selectedIds.length === 0) {
      addToast(t("message.not_selected_information"), {
        appearance: "warning",
        autoDismiss: true,
      });
      return;
    }
    exportOrders();
  };

  const onSetDaySize = () => {
    if (window.matchMedia("(max-width: 560px)").matches) {
      return 22;
    }
    if (window.matchMedia("(max-width: 800px)").matches) {
      return 24;
    }
    return undefined;
  };

  /* ================================ END FUNCTION HANDLER ================================= */

  const initColumns = [
    // {
    //   dataField: "address_type",
    //   text: "Loại địa chỉ",
    //   sort: false,
    //   formatter: (_cell, row) => {
    //     const isRowLevel2 = row?.is_new_address === "N";
    //     return (
    //       <span
    //         className={`badge ${isRowLevel2 ? "bg-info" : "bg-secondary"}`}
    //         style={{
    //           fontSize: "11px",
    //           padding: "4px 8px",
    //           textAlign: "center",
    //           display: "inline-block",
    //         }}
    //       >
    //         {isRowLevel2 ? "2 cấp" : "3 cấp"}
    //       </span>
    //     );
    //   },
    // },
    {
      dataField: "maker_date",
      text: "Thời gian tạo",
      sort: true,
      headerStyle: (colum, colIndex) => {
        return { width: "80px" };
      },
      formatter: (cell, row) => {
        if (cell) {
          return new Intl.DateTimeFormat("en-GB", {
            year: "numeric",
            month: "2-digit",
            day: "2-digit",
            hour: "2-digit",
            minute: "2-digit",
          })
            .format(Number(cell) * 1000)
            .replace(",", "");
        } else {
          return "";
        }
      },
    },
    {
      dataField: "type",
      text: t("table.type"),
      sort: true,
      formatter: cell => {
        return findOrderType(cell, listOrderType)?.label;
      },
    },
    {
      dataField: "order_code",
      text: t("table.id"),
      sort: true,
    },
    {
      dataField: "ref_code",
      text: t("table.package_code"),
      sort: true,
      formatter: (cell, row) => {
        const isAllowUpdateRefCode =
          row?.shipping_type === 3 && (row?.status === 1 || row?.status === 6); // Là đơn chành xe: shipping_type = 3 , trạng thái đơn là: tạo đơn, đang chờ

        const isAllowUpdateExistRefCode =
          checkItemAcceptForUpdateExitsRefCode(row);
        return (
          <RefCode
            t={t}
            ref_code={cell}
            data={row}
            isAllowUpdateRefCode={isAllowUpdateRefCode}
            onUpdateRefCode={() => {
              updateRefCodeModalRef?.current?.openModal({
                orderId: row?.id,
                orderRefCode: row.ref_code,
              });
            }}
            isAllowUpdateExistRefCode={isAllowUpdateExistRefCode}
            onUpdateExistRefCode={() => {
              updateRefCodeModalRef?.current?.openModal({
                orderId: row?.id,
                orderRefCode: row.ref_code,
                isUpdateExist: true,
              });
            }}
            isTrackingTransport={false}
          />
        );
      },
    },
    {
      dataField: "status",
      text: t("table.status"),
      sort: true,
      formatter: cell => {
        return formatStatus(cell);
      },
    },
    {
      dataField: "sender_name",
      text: t("table.customer"),
      sort: true,
      formatter: (cell, row) => {
        return row.type === 1 ? row.reciever_name : row.sender_name;
      },
    },
    {
      dataField: "sender_contact_phone",
      text: t("table.SDT"),
      sort: true,
      formatter: (cell, row) => {
        return row.type === 1
          ? row.reciever_contact_phone
          : row.sender_contact_phone;
      },
    },
    {
      dataField: "address",
      text: t("table.address"),
      sort: true,
      formatter: (cell, row) => (
        <div
          dangerouslySetInnerHTML={{
            __html: splitText(
              row.type === ORDER_TYPE.RETURN.value
                ? row.reciever_full_address
                : row.sender_full_address,
              [
                {
                  limit_width: 3000,
                  limit_text_length: 50,
                },
                {
                  limit_width: 600,
                  limit_text_length: 30,
                },
              ]
            ),
          }}
        />
      ),
    },
    {
      dataField: "transport_id",
      text: t("table.transport_id"),
      sort: true,
      formatter: (cell, row) => {
        return row.transport_name;
      },
    },
    {
      dataField: "time_slot_name",
      text: t("table.timeslot_id"),
      sort: true,
      formatter: (cell, row) => {
        return cell;
      },
    },
  ];

  const listRowAction = [
    {
      actionAccess: actionAccess.GLOG_FUNCTION_MY_ORDER_VIEW,
      icon: <i className="fas fa-eye fa-lg text-primary ms-2" />,
      text: t("actions.view"),
      onClick: clickViewOrderHandler,
      onRightClick: rightClickViewOrderHandler,
    },
    {
      actionAccess: actionAccess.GLOG_FUNCTION_MY_ORDER_CLONE,
      icon: <i className="fas fa-copy fa-lg text-success ms-2" />,
      text: t("actions.copy"),
      conditionVisible: {
        type: [orderTypeMode.RECEIVE_TYPE],
      },
      onClick: clickCopyOrderHandler,
    },
    {
      actionAccess: actionAccess.GLOG_FUNCTION_MY_ORDER_CANCEL,
      icon: <i className="fas fa-times fa-lg text-danger ms-2" />,
      text: t("actions.cancel"),
      conditionVisible: {
        status: [orderStatusMode.WAITING],
      },
      onClick: clickCancelOrderHandler,
    },
  ];
  const rowActionList = CheckActionAccessList(listRowAction, "actionAccess");

  const selectRow = {
    mode: "checkbox",
    // clickToSelect: true,
    bgColor: "#00BFFF",
    onSelect: handleRowsSelect,
  };

  useEffect(() => {
    if (filterType) {
      setOrderParams(prev => ({
        ...prev,
        page: 1,
        sizePerPage: 10,
        columnFilter: {
          ...prev.columnFilter,
          "filter[type]": filterType,
        },
      }));
    }
  }, [filterType]);

  return (
    <React.Fragment>
      <div className="page-content">
        <MetaTags>
          <title>My Orders</title>
        </MetaTags>
        <div className="container-fluid">
          <BreadcrumbWithLink
            title={t("title.order") + ` (${fetchOrders?.totalCount || 0})`}
          />
          <UpdateRefCodeModal
            ref={updateRefCodeModalRef}
            handleOnSuccessInsertOrderRefCode={() => {
              listOrders();
            }}
          />
          <Row>
            {/* Modal START*/}
            <Col className="col-12">
              {/* Delete Order Modal */}
              <ConfirmModal
                isOpen={cancelOrderModal}
                titleHeader={
                  t("actions.deleteModal.title") +
                  `${selectedRow?.["order_code"]}` +
                  "?"
                }
                titleBody={t("actions.deleteModal.content")}
                onConfirm={cancelSingleOrderHandler}
                textBtnConfirm={t("actions.deleteModal.confirmBtn")}
                textBtnCancel={t("actions.deleteModal.cancelBtn")}
                toggle={toggleCancelOrderModal}
                isReasonDeleteCheckbox={true}
                reasonList={reasonListData?.items}
                isHaveNote={true}
              />
            </Col>
            {/* Modal E N D*/}
            <Col className="col-12">
              <Card>
                <CardBody>
                  <RemoteDataTable
                    keyField="id"
                    data={fetchOrders?.items || []}
                    columns={columnsTable}
                    selectRow={selectRow}
                    page={fetchOrders?.params?.page}
                    sizePerPage={fetchOrders?.params?.sizePerPage}
                    totalSize={fetchOrders?.totalCount}
                    onTableChange={handleTableChange}
                    onSearchAllHandle={onSearchAllHandle}
                    listRowAction={rowActionList}
                    onRowsSelect={handleRowsSelect}
                    loading={isLoadingListOrder}
                    searchSticky={true}
                    sizePerPageListAppend={[
                      {
                        text: "100",
                        value: 100,
                      },
                    ]}
                  >
                    <div
                    // className="d-flex flex-column flex-sm-row flex-grow-0 flex-md-grow-1 justify-content-between"
                    // style={{ gap: "0.5rem" }}
                    >
                      <div
                        className="d-flex flex-column flex-md-row mb-md-0 flex-wrap"
                        style={{ gap: "0.5rem" }}
                      >
                        {/* <Label
                          className="d-flex align-items-center gap-1"
                          style={{ cursor: "pointer" }}
                          htmlFor="is_level_2"
                          onClick={() => handleChangeIsLevel2(!is_level_2)}
                        >
                          <Switch
                            className=""
                            checked={is_level_2}
                            onChange={handleChangeIsLevel2}
                          />
                          Địa chỉ 2 cấp
                        </Label> */}
                        <div>
                          <DateRangePicker
                            numberOfMonths={1}
                            startDate={startDate}
                            startDateId="s_id"
                            endDate={endDate}
                            endDateId="e_id"
                            startDatePlaceholderText={t("title.startDate")}
                            endDatePlaceholderText={t("title.endDate")}
                            isOutsideRange={() => false}
                            onDatesChange={handleDateRangeFilter}
                            focusedInput={focusedInput}
                            onFocusChange={e => setFocusedInput(e)}
                            displayFormat="DD/MM/YYYY"
                            daySize={onSetDaySize()}
                            orientation={
                              window.matchMedia("(max-width: 450px)").matches
                                ? "vertical"
                                : "horizontal"
                            }
                          />
                        </div>
                        <div>
                          <Dropdown
                            isOpen={statusFilter}
                            toggle={() => setStatusFilter(!statusFilter)}
                          >
                            <DropdownToggle
                              className="btn primary-btn w-100"
                              caret
                            >
                              {t("filters.status.label")}
                              {selectedStatusFilter && (
                                <span>:&nbsp;{selectedStatusFilter}</span>
                              )}
                              <i className="mdi mdi-chevron-down" />
                            </DropdownToggle>
                            <DropdownMenu className="w-100">
                              {statusListAllOptions?.length > 0 &&
                                statusListAllOptions.map((status, index) => (
                                  <DropdownItem
                                    key={index}
                                    onClick={() => handleStatusFilter(status)}
                                  >
                                    {status.label}
                                  </DropdownItem>
                                ))}
                            </DropdownMenu>
                          </Dropdown>
                        </div>
                        {/* <div>
                          <Dropdown
                            isOpen={isOrderTypeFilter}
                            toggle={() =>
                              setOrderTypeFilter(!isOrderTypeFilter)
                            }
                          >
                            <DropdownToggle
                              className="btn primary-btn w-100"
                              caret
                            >
                              {t("filters.type.label")}
                              {selectedOrderTypeFilter && (
                                <span>:&nbsp;{selectedOrderTypeFilter}</span>
                              )}
                              <i className="mdi mdi-chevron-down" />
                            </DropdownToggle>
                            <DropdownMenu className="w-100">
                              {orderTypeAllOptions.map((type, index) => (
                                <DropdownItem
                                  key={`order-type-${index}`}
                                  onClick={() => handleOrderTypeFilter(type)}
                                >
                                  {type.label}
                                </DropdownItem>
                              ))}
                            </DropdownMenu>
                          </Dropdown>
                        </div> */}
                        {/* <div>
                          <Button
                            className="w-100"
                            color= {isFilterRunner ? "primary" : "secondary"}
                            type="button"
                            onClick={() => {
                              handleRunnerFilter()
                            }}
                          >
                            {"Runner"}
                          </Button>
                        </div>  */}
                        <GroupButtonOrderType
                          currentValue={
                            orderParams?.columnFilter["filter[type]"]
                          }
                          disabled={isLoadingListOrder}
                          onChange={type => setFilterType(type.value)}
                        />
                        <div>
                          <Button
                            className="mb-2 w-100"
                            color={
                              isFilterConsolidated ? "primary" : "secondary"
                            }
                            disabled={isLoadingListOrder}
                            type="button"
                            onClick={() => {
                              handleConsolidatedFilter();
                            }}
                          >
                            {"Đơn gom"}
                          </Button>
                        </div>
                      </div>
                      <div className="d-flex flex-wrap gap-2">
                        {isAllowCreate && (
                          <Button
                            className="mb-2"
                            color="primary"
                            type="button"
                            onClick={() => {
                              navigate(
                                `/my-orders/create${
                                  selectedOrderCode?.length > 0
                                    ? `/?sub_order_codes=${selectedOrderCode.join(
                                        ","
                                      )}`
                                    : ""
                                }`
                              );
                            }}
                          >
                            {"Tạo đơn mới"}
                          </Button>
                          // <div>
                          //   <Dropdown
                          //     isOpen={orderType}
                          //     toggle={() => setOrderType(!orderType)}
                          //   >
                          //     <DropdownToggle className="btn primary-btn" caret>
                          //       {t("actions.createNewOrder.title")}{" "}
                          //       <i className="mdi mdi-chevron-down" />
                          //     </DropdownToggle>
                          //     <DropdownMenu>
                          //       <DropdownItem
                          //         tag={Link}
                          //         to={`hcm-create${
                          //           selectedOrderCode.length > 0
                          //             ? `/?sub_order_codes=${selectedOrderCode.join(
                          //                 ","
                          //               )}`
                          //             : ""
                          //         }`}
                          //       >
                          //         {t("actions.createNewOrder.hcmOrder")}
                          //       </DropdownItem>
                          //       <DropdownItem
                          //         tag={Link}
                          //         to={`district-create${
                          //           selectedOrderCode.length > 0
                          //             ? `/?sub_order_codes=${selectedOrderCode.join(
                          //                 ","
                          //               )}`
                          //             : ""
                          //         }`}
                          //       >
                          //         {t("actions.createNewOrder.provinceOrder")}
                          //       </DropdownItem>
                          //     </DropdownMenu>
                          //   </Dropdown>
                          // </div>
                        )}
                        <Button
                          className="mb-2"
                          type="button"
                          color="danger"
                          onClick={() => {
                            navigate("/collection-order/create");
                          }}
                        >
                          {"Tạo đơn lấy máu"}
                        </Button>
                        {isAllowExport && (
                          <Dropdown
                            isOpen={actionType}
                            toggle={() => setActionType(!actionType)}
                          >
                            <DropdownToggle className="btn primary-btn" caret>
                              Tác vụ <i className="mdi mdi-chevron-down" />{" "}
                              {!!isExportingFile && (
                                <Spinner
                                  // style={{ marginLeft: "5px" }}
                                  color="white"
                                  size="sm"
                                />
                              )}
                            </DropdownToggle>
                            <DropdownMenu>
                              <DropdownItem onClick={handleExportFile}>
                                {t("actions.exportFile")}
                              </DropdownItem>
                            </DropdownMenu>
                          </Dropdown>
                        )}
                      </div>
                    </div>
                  </RemoteDataTable>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </div>
      </div>
    </React.Fragment>
  );
};

export default MyOrderPage;
